import { ModalPopup, ModalSlideContent } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { Provider } from 'react-redux';
import styled from 'styled-components';
import { CustomQuestionContainer } from '../../containers/questions/CustomQuestionContainer';
import ContentConstants from '../../contentConstants';
import { ICustomQuestionActionCreators, ISurveyQuestionEditModel } from '../../models';
import { WarningModal } from '../common';

export interface ICustomQuestionEditModalProps {
	question: ISurveyQuestionEditModel;
	isOpen: boolean;
	ToggleModal: (isOpen: boolean) => void;
	store: any;
}

export type CustomQuestionProps = { unsavedChanges: boolean } & ICustomQuestionEditModalProps & ICustomQuestionActionCreators;

export const StyledModalSlideContent = styled(ModalSlideContent)`
	width: 100%;
	white-space: normal;
`;
export interface ICustomQuestionEditModalState {
	isWarningModalOpen: boolean;
}

export class CustomQuestionEditModal extends React.PureComponent<CustomQuestionProps, ICustomQuestionEditModalState> {
	constructor(props: CustomQuestionProps) {
		super(props);

		this.state = { isWarningModalOpen: false };

		this.ToggleWarningModal = this.ToggleWarningModal.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleWarningModalClose = this.handleWarningModalClose.bind(this);
	}

	public render() {
		const { question, isOpen, ToggleModal } = this.props;
		const isFollowUp = !!question.parentQuestionId;
		return (
			<>
				<ModalPopup
					isOpen={isOpen}
					title={ContentConstants.TITLE_UPDATE_SURVEY_QUESTION}
					onClosed={this.handleClose}
					contentfullwidth={true}
					contenthcentered={true}
				>
					<StyledModalSlideContent contentId={1} key={1}>
						<Provider store={this.props.store}>
							<CustomQuestionContainer
								isDemographic={question.isDemographic}
								isFollowUp={isFollowUp}
								questionId={question.surveyQuestionId}
								parentQuestionId={question.parentQuestionId}
								fromQuestionModal={false}
								OnFinish={() => ToggleModal(false)}
								ToggleWarningModal={ToggleModal}
							/>
						</Provider>
					</StyledModalSlideContent>
				</ModalPopup>
				<WarningModal
					isOpen={this.state.isWarningModalOpen}
					onClose={() => this.ToggleWarningModal(false)}
					onSubmit={this.handleWarningModalClose}
					contentHeadline={ContentConstants.WARNING_MODAL_UNSAVED_HEADLINE}
					contentBody={ContentConstants.WARNING_MODAL_UNSAVED_BODY}
				/>
			</>
		);
	}

	public handleWarningModalClose() {
		this.props.ResetCustomQuestion();
		this.ToggleWarningModal(false);
		this.props.ToggleModal(false);
	}

	public handleClose() {
		if (this.props.unsavedChanges) {
			this.ToggleWarningModal(true);
		} else {
			this.props.ToggleModal(false);
		}
	}

	public ToggleWarningModal(isOpen: boolean) {
		this.setState({ isWarningModalOpen: isOpen });
	}
}
